import { render } from "./tasksmodal.vue?vue&type=template&id=3a979120"
import script from "./tasksmodal.vue?vue&type=script&lang=js"
export * from "./tasksmodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__